import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeModeProvider, useThemeMode } from './components/ThemeModeContext';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Chat from './pages/Chat';
import Start from './pages/Start';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Run from './pages/Run';
import AccountPage from './pages/AccountPage';
import IconEditor from './pages/IconEditor';
import UpdateCredit from './pages/UpdateCredit';
import TokenCost from './pages/TokenCost';
import './App.css';

function RoutesWithTheme() {
  const { isDarkMode } = useThemeMode();
  const theme = React.useMemo(() => createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        main: isDarkMode ? '#90caf9' : '#003366'
      },
      background: {
        default: isDarkMode ? '#121212' : '#ffffff',
        paper: isDarkMode ? '#1e1e1e' : '#ffffff'
      }
    }
  }), [isDarkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/start" element={<Start />} />
          <Route path="/run" element={<Run />} />
          <Route path="/run/:id" element={<Run />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/icon-editor" element={<IconEditor />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/update-credit" element={<UpdateCredit />} />
          <Route path="/token-cost" element={<TokenCost />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <RoutesWithTheme />
    </ThemeModeProvider>
  );
}

export default App;
